module.exports = __webpack_public_path__ + "media/images/logos/Brown-University-22f4d9fbc6f4a42712bb1f78a14812e1.svg";